var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgE4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: 292,
    height: 186,
    viewBox: "0 0 292 186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(-1036.5 -2001)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "physical_violence",
    "data-name": "physical violence",
    transform: "translate(1182.5 2095)",
    fill: "#9c3230",
    fontSize: 77,
    fontFamily: "Oswald-Bold, Oswald",
    fontWeight: 700,
    letterSpacing: "-0.06em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -139.293,
    y: 0
  }, "PHYSICAL"), /*#__PURE__*/React.createElement("tspan", {
    x: -132.979,
    y: 70
  }, "VIOLENCE")), /*#__PURE__*/React.createElement("text", {
    id: "Emotional_abuse_can_progress_into",
    "data-name": "Emotional abuse can progress into",
    transform: "translate(1182.5 2025)",
    fill: "#1d1d1d",
    fontSize: 20,
    fontFamily: "Oswald-Medium, Oswald",
    fontWeight: 500,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -145.94,
    y: 0
  }, "EMOTIONAL ABUSE CAN PROGRESS INTO")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgE4);
export default __webpack_public_path__ + "static/media/e4.65da00d6dabf24d939a95fc083a3d151.svg";
export { ForwardRef as ReactComponent };